import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule, Router, RoutesRecognized } from '@angular/router';
import { filter } from 'rxjs';
import { Route, mapRoutes } from '../SEO_Constant/routes.constant';
import { AndroidAppDevelopmentComponent } from './Appsolution/android-app-development/android-app-development.component';
import { HybridAppDevelopmentComponent } from './Appsolution/hybrid-app-development/hybrid-app-development.component';
import { IosAppDevelopmentComponent } from './Appsolution/ios-app-development/ios-app-development.component';
import { NativeAppDevelopmentComponent } from './Appsolution/native-app-development/native-app-development.component';
import { BulkSmsAndEmailMarketingComponent } from './digitalmarketing/bulk-sms-and-email-marketing/bulk-sms-and-email-marketing.component';
import { DigitalMediaMarketingComponent } from './digitalmarketing/digital-media-marketing/digital-media-marketing.component';
import { SearchEngineOptimizationComponent } from './digitalmarketing/search-engine-optimization/search-engine-optimization.component';
import { SocialMediaPromotionComponent } from './digitalmarketing/social-media-promotion/social-media-promotion.component';
import { BulkSmsComponent } from './moreservices/bulk-sms/bulk-sms.component';
import { DigitalVisitingCardComponent } from './moreservices/digital-visiting-card/digital-visiting-card.component';
import { GraphicDesignComponent } from './moreservices/graphic-design/graphic-design.component';
import { LogoDesignComponent } from './moreservices/logo-design/logo-design.component';
import { VideoCreationComponent } from './moreservices/video-creation/video-creation.component';
import { DataentryComponent } from './websolution/dataentry/dataentry.component';
import { EcommercesolutionComponent } from './websolution/ecommercesolution/ecommercesolution.component';
import { SoftwareDevelopmentComponent } from './websolution/software-development/software-development.component';
import { WebApplicationDevelopmentComponent } from './websolution/web-application-development/web-application-development.component';
import { WebHostingSolutionsComponent } from './websolution/web-hosting-solutions/web-hosting-solutions.component';
import { WebsiteDesigningComponent } from './websolution/website-designing/website-designing.component';




@Component({
    'template': ``,
    'styles': [``],
    standalone: false
})
export class pnf {
  constructor(private router: Router){
    let goto = '/';
    routes.map((r)=> {
      if((r.path)?.toLowerCase() === (router.url.replace('/service/', '')).toLowerCase()){
        goto = '/service/'+r.path
      }
    })
    console.log(goto)
    router.navigate([goto])
  }
}


const routes: Routes = [
  {
    path: 'android-app-development',
    component: AndroidAppDevelopmentComponent,
  },
  {
    path: 'web-Hosting-Solutions',
    component: WebHostingSolutionsComponent,
  },
  {
    path: 'web-hosting-solutions',
    component: WebHostingSolutionsComponent,
  },
  {
    path: 'hybrid-app-development',
    component: HybridAppDevelopmentComponent,
  },

  {
    path: 'native-app-development',
    component: NativeAppDevelopmentComponent,
  },

  {
    path: 'ios-app-development',
    component: IosAppDevelopmentComponent,
  },

  {
    path: 'software-Development',
    component: SoftwareDevelopmentComponent,
  },
  {
    path: 'software-development',
    component: SoftwareDevelopmentComponent,
  },
  {
    path: 'web-development',
    component: SoftwareDevelopmentComponent,
  },
  {
    path: 'Web-Application-Development',
    component: WebApplicationDevelopmentComponent,
  },
  {
    path: 'web-application-development',
    component: WebApplicationDevelopmentComponent,
  },
  {
    path: 'social-Media-Promotion',
    component: SocialMediaPromotionComponent,
  },
  {
    path: 'social-media-promotion',
    component: SocialMediaPromotionComponent,
  },
  {
    path: 'search-Engine-Optimisation',
    component: SearchEngineOptimizationComponent,
  },
  {
    path: 'search-engine-optimisation',
    component: SearchEngineOptimizationComponent,
  },
  {
    path: 'digital-Media-Marketing',
    component: DigitalMediaMarketingComponent,
  },
  {
    path: 'digital-media-marketing',
    component: DigitalMediaMarketingComponent,
  },
  {
    path: 'bulk-Sms-and-Email-Marketing',
    component: BulkSmsAndEmailMarketingComponent,
  },
  {
    path: 'bulk-sms-and-email-marketing',
    component: BulkSmsAndEmailMarketingComponent,
  },
  {
    path: 'logo-Design',
    component: LogoDesignComponent,
  },
  {
    path: 'logo-design',
    component: LogoDesignComponent,
  },
  {
    path: 'graphic-Design',
    component: GraphicDesignComponent,
  },
  {
    path: 'graphic-design',
    component: GraphicDesignComponent,
  },
  {
    path: 'digital-Visiting-Card',
    component: DigitalVisitingCardComponent,
  },
  {
    path: 'digital-visiting-card',
    component: DigitalVisitingCardComponent,
  },
  {
    path: 'video-Creation',
    component: VideoCreationComponent,
  },
  {
    path: 'video-creation',
    component: VideoCreationComponent,
  },
  {
    path: 'bulkSms',
    component: BulkSmsComponent,
  },
  {
    path: 'website-Design',
    component: WebsiteDesigningComponent,
  },
  {
    path: 'website-design',
    component: WebsiteDesigningComponent,
  },
  {
    path: 'website-designing',
    component: WebsiteDesigningComponent,
  },
  {
    path: 'EcommerceSolution',
    component: EcommercesolutionComponent,
  },
  {
    path: 'DataEntry',
    component: DataentryComponent,
  },
  ...mapRoutes(),
  {
    path: '**',
    component: pnf
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceRoutingModule {}

